import { AxiosError } from "axios"

class ErrorHandler {
  protected errorHandler(e: unknown) {
    const error = e as AxiosError

    if (error.response) {
      return {
        status: error.response.status,
        error
      }
    }

    throw e
  }
}

export default ErrorHandler
